export default __webpack_public_path__ + "static/media/04_galago.856492db.webp";